import { render, staticRenderFns } from "./NewReferral.vue?vue&type=template&id=bffd0104&scoped=true&"
import script from "./NewReferral.vue?vue&type=script&lang=js&"
export * from "./NewReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffd0104",
  null
  
)

export default component.exports